import { useUserStore } from '@/stores/userStore'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/auth',
      name: 'auth',
      component: () => import('@/view/Auth.vue'),
      meta: { layout: 'auth' },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/view/Home.vue'),
      meta: { layout: 'main' },
    },
    {
      path: '/vacancy/:id',
      name: 'vacancy-view',
      component: () => import('@/view/VacancyView.vue'),
      meta: { layout: 'main' },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/view/Settings.vue'),
      meta: { layout: 'main' },
      children: [
      ],
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/view/Admin.vue'),
      meta: { layout: 'main' },
      children: [
        {
          path: '/admin/clients-list',
          name: 'clients-list',
          component: () => import('@/view/subview/clients/ClientsList.vue'),
          meta: { layout: 'main' },
        },
        {
          path: '/admin/video-tutorials-stat',
          name: 'video-tutorials-stat',
          component: () => import('@/view/subview/videotutorials/VideoTutorials.vue'),
          meta: { layout: 'main' },
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const userStore = useUserStore()

  if (!userStore.inited) {
    await userStore.initUser()
  }

  if (!userStore.me && to.path !== '/auth') {
    return { path: '/auth' }
  }

  if (userStore.me && to.path === '/auth') {
    return { path: '/' }
  }
})

export default router
